


























































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import * as api from "@/api";
import * as models from "@/api/models";
@Component({})
export default class EditPasswordIndex extends Vue {
  form: any = {};
  formData: any = {};
  passwordErrorCode: string = "";
  beforeMount() {
    this.form = this.$form.createForm(this, {});
  }
  mounted() {}
  async handleSubmit() {
    this.form.validateFields(async (err: any, fieldsValue: any) => {
      if (!err) {
        const values = {
          ...fieldsValue,
        };
        this.formData = Object.assign(this.formData, values);
        const data: any = await api.Clients.changePassword_POST(this.formData);

        if (data!.success) {
          this.success();
        } else {
          this.$message.error(data.message);
        }
      }
    });
  }

  //修改成功提示框
  async success() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let _this = this;
    this.$success({
      title: "信息提示",
      content: "修改成功！",
      onOk() {
        _this.form = _this.$form.createForm(_this, {});
      },
    });
  }

  //验证原密码
  validatorOldPassword(rule: any, value: string, callback: any) {
    if (this.passwordErrorCode == "PasswordMismatch") {
      callback(new Error("原密码不正确，请重新输入！"));
      this.passwordErrorCode = "";
    } else {
      this.form.password = value;
      callback();
    }
  }

  //验证新密码
  validatorPassword(rule: any, value: string, callback: any) {
    // ^(?![0-9]+$)(?![a-z]+$)(?![A-Z]).{6,}$
    // ^(?![0-9]+$)(?![a-z]+$)[0-9a-z]{6,}$
    const patt = new RegExp("^(?![0-9]+$)(?![a-z]+$)(?![A-Z]).{8,}$");
    if (value == this.form.password) {
      callback(new Error("新密码不允许和原密码相同！"));
    } else {
      if (!patt.test(value)) {
        callback(
          new Error(
            '密码必须由大于等于8位包含"a-zA-Z"的字母、数字、特殊符号其中的两种组成！'
          )
        );
      } else {
        this.form.newPassword = value;
        callback();
      }
    }
  }
  //验证确认密码是否等于新密码
  validatorPasswordConfirm(rule: any, value: string, callback: any) {
    if (value != this.form.newPassword) {
      callback(new Error("确认密码不等于新密码"));
    } else {
      callback();
    }
  }
}
